import ebUrl from '../../simple-flow/eb-url';
import sFetch from '../../simple-flow/s-fetch';

import americanFootBall from '../../assets/dist-assets/venue-stencils/american-football.png';
import baseball from '../../assets/dist-assets/venue-stencils/baseball.png';
import basketball from '../../assets/dist-assets/venue-stencils/basketball.png';
import boxing from '../../assets/dist-assets/venue-stencils/boxing.png';
import cricket from '../../assets/dist-assets/venue-stencils/cricket.png';
import hockey from '../../assets/dist-assets/venue-stencils/hockey.png';
import lacrosse from '../../assets/dist-assets/venue-stencils/lacrosse.png';
import raceTrack from '../../assets/dist-assets/venue-stencils/race-track.png';
import rugby from '../../assets/dist-assets/venue-stencils/rugby.png';
import soccer from '../../assets/dist-assets/venue-stencils/soccer.png';
import swimmingPool from '../../assets/dist-assets/venue-stencils/swimming-pool.png';
import tennis from '../../assets/dist-assets/venue-stencils/tennis.png';
import track from '../../assets/dist-assets/venue-stencils/track.png';
import volleyBall from '../../assets/dist-assets/venue-stencils/volleyball.png';

const STENCIL_MAP = {
    'venue-stencils/american-football.png': americanFootBall,
    'venue-stencils/baseball.png': baseball,
    'venue-stencils/basketball.png': basketball,
    'venue-stencils/boxing.png': boxing,
    'venue-stencils/cricket.png': cricket,
    'venue-stencils/hockey.png': hockey,
    'venue-stencils/lacrosse.png': lacrosse,
    'venue-stencils/race-track.png': raceTrack,
    'venue-stencils/rugby.png': rugby,
    'venue-stencils/soccer.png': soccer,
    'venue-stencils/swimming-pool.png': swimmingPool,
    'venue-stencils/tennis.png': tennis,
    'venue-stencils/track.png': track,
    'venue-stencils/volleyball.png': volleyBall,
};

const { aFetch } = sFetch;

const { getAppUrl } = ebUrl;

const aGetAsset = async ({ assetPath, type }) => {
    if (!type) {
        throw new Error('Please specify fetch type (json|binary|text)');
    }

    const stencilPath = STENCIL_MAP[assetPath];
    const assetUrl = stencilPath ? stencilPath : getAppUrl(assetPath);

    console.log(`asset: ${assetPath}: `, assetUrl);
    const asset = await aFetch({ type, url: assetUrl });

    return asset;
};

export default {
    aGetAsset,
};
